module.exports = __webpack_public_path__ + "static/media/briefcase.e875aebd.svg";